import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { buildPageLink } from 'Views/Page/Content/Templates';
import { clientPaths } from 'Consts/Strings';
import useHomeContext from 'Context/HomeContext';
import { Action } from './Action';

export const Plan = ({ onClick }) => {
  const { homeResource } = useHomeContext();
  return homeResource.withRelationship(
    fr.relationships.planPage.name,
    (rel) => (
      <Action
        value="plan"
        label="Plan"
        icon="star"
        to={buildPageLink(rel.link('related'), clientPaths.planPage)}
        onClick={onClick}
      />
    ),
    () => null,
  );
};

Plan.defaultProps = {
  onClick: undefined,
};
Plan.propTypes = {
  onClick: PropTypes.func,
};
